export type Capability =
  | "quotation.manage"
  | "quotation.remove_item"
  | "order.manage"
  | "checkin.manage"
  | "catalog.manage"
  | "alerts.manage"
  | "dashboard.operations"
  | "finance.view"
  | "users.manage"
  | "settings.manage"
  | "audit.view"
  | "destructive.manage";

type PermissionSubject = {
  permissions?: readonly Capability[];
};

// This only projects the capabilities granted by GET /me for UI visibility.
// API authorization remains the server's responsibility.
export function can(
  user: PermissionSubject | null | undefined,
  capability: Capability,
): boolean {
  return user?.permissions?.includes(capability) ?? false;
}
